import { HighlightOff } from '@mui/icons-material';
import * as React from 'react';
import styled from 'styled-components';

const Banner = styled.div<{ showBanner: boolean }>`
  background-color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.turquoise.T300
      : props.theme.atlas.semantic.color.action.primary.default};
  padding-top: ${(props) => (props.showBanner ? props.theme.spacing() : '0')}px;
  padding-bottom: ${(props) =>
    props.showBanner ? props.theme.spacing() : '0'}px;
  margin-bottom: ${(props) => props.theme.spacing()}px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-height: ${(props) => (props.showBanner ? '70px' : '0px')};
  transition:
    max-height 0.7s cubic-bezier(0.42, 0, 0.58, 1),
    padding 0.7s linear;
`;

const BannerContent = styled.div<{ showBanner: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-left: ${(props) => props.theme.spacing() + 24}px;
  opacity: ${(props) => (props.showBanner ? 1 : 0)};
  transition: opacity 0.5s;
  transition-timing-function: cubic-bezier(0, 0.5, 0, 1);
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
`;

const Close = styled(HighlightOff)`
  display: flex;
  color: ${(props) =>
    props.theme.isVaultVariant
      ? props.theme.newPalette.neutral.N0
      : props.theme.atlas.semantic.color.type.inverse};
  justify-self: end;
  margin-right: ${(props) => props.theme.spacing()}px;
`;

interface Props {
  toggleBanner: React.Dispatch<React.SetStateAction<boolean>>;
  showBanner: boolean;
}

const ChartReportClosedBanner = ({ toggleBanner, showBanner }: Props) => {
  return showBanner ? (
    <Banner showBanner={showBanner}>
      <BannerContent showBanner={showBanner}>
        <p>This report has been closed</p>
      </BannerContent>
      <Close onClick={() => toggleBanner(false)} />
    </Banner>
  ) : null;
};

export default ChartReportClosedBanner;
